import { useDasApiQuery } from 'lib/api/useApiQuery';

export const useCheckContractDeployed = () => {
  const { data, error, isLoading, refetch } = useDasApiQuery(
    'check_contract_deployed',
    {
      queryOptions: {
        refetchOnMount: false,
        retry: false,
      },
    },
  );

  return {
    data,
    error,
    refetch,
    isLoading,
  };
};
